import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('add_an_approval_step'),
    step: defineMessage('step'),
};
